<template>
  <!-- 商品评价分析 -->
  <div>
    <div class="allGoodsAssess">
      <!-- 头部查询表单 -->
      <div class="headForm">
        <div class="headTips">
          <div class="leftFlex">
            <h4 style="color: #2e3458; font-size: 16px; font-weight: bold">
              商品评价分析
            </h4>
            <div
              style="
                float: left;
                background-color: #fffaee;
                padding: 5px 12px;
                border-radius: 14px;
              "
            >
              <img
                src="@/assets/images/new_icon_waring_yellow.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 0px 4px 0px 0px;
                "
              />
              <span class="desc"
                >列表商品前100默认为热销前100sku，100之后无热销排名</span
              >
            </div>
          </div>
        </div>
        <div style="padding-top: 20px; padding-bottom: 20px">
          <input-form
            :inputData="inputData"
            :deleteNull="true"
            :time="6"
            @toParentVal="queryList"
            ref="searchForm"
          ></input-form>
        </div>
      </div>

      <div class="content">
        <!-- 按钮区块 -->
        <div class="titBtns">
          <div class="leftBtn">
            <!-- <button class="refreshBtn" @click.prevent="handleUpdate">
              <img
                src="../../assets/images/refresh.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 0px 4px 0px 0;
                "
              />更新
            </button> -->
            <button
              class="synchroBtn"
              v-zoom="{ from: pageName, name: '同步店铺商品' }"
              @click.prevent="syncShopGood"
            >
              同步店铺商品
            </button>
            <el-button
              class="downloadBtn"
              v-zoom="{ from: pageName, name: '下载数据' }"
              @click.prevent="handleDownload"
            >
              下载数据
            </el-button>
          </div>
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          v-loading="loading"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="serial" label="序号">
            <template slot-scope="scope">
              {{ scope.row.serial + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="商品信息" width="350">
            <template slot-scope="scope">
              <a :href="scope.row.itemUrl" target="_blank">
                <div class="shopInfo">
                  <img :src="scope.row.logo" class="avar" alt="商品图片" />
                  <div class="descBox">
                    <span class="tit">{{ scope.row.wareTitle }}</span>
                    <span class="shopId">SKU ID：{{ scope.row.skuId }}</span>
                  </div>
                </div>
              </a>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="wareId" label="商品编码" width="150"></el-table-column> -->
          <el-table-column label width="20"></el-table-column>
          <el-table-column
            prop="totalCommentNum"
            label="评价总数"
            width="130"
          ></el-table-column>
          <el-table-column label="好评数(5星/4星)" width="150">
            <template slot-scope="scope">
              <span
                v-if="scope.row.fiveScoreNumber && scope.row.fourScoreNumber"
                >{{
                  scope.row.fiveScoreNumber + scope.row.fourScoreNumber
                }}</span
              >
              <span v-else-if="scope.row.fiveScoreNumber">{{
                scope.row.fiveScoreNumber
              }}</span>
              <span v-else-if="scope.row.fourScoreNumber">{{
                scope.row.fourScoreNumber
              }}</span>
              <span
                v-if="scope.row.fiveScoreNumber && scope.row.fourScoreNumber"
                >({{ scope.row.fiveScoreNumber }}、{{
                  scope.row.fourScoreNumber
                }})</span
              >
              <span v-else-if="scope.row.fiveScoreNumber"
                >({{ scope.row.fiveScoreNumber }}、0)</span
              >
              <span v-else-if="scope.row.fourScoreNumber"
                >(0、{{ scope.row.fourScoreNumber }})</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="center" label="中评数(3星/2星)" width="150">
            <template slot-scope="scope">
              <span
                v-if="scope.row.threeScoreNumber && scope.row.twoScoreNumber"
                >{{
                  scope.row.threeScoreNumber + scope.row.twoScoreNumber
                }}</span
              >
              <span v-else-if="scope.row.threeScoreNumber">{{
                scope.row.threeScoreNumber
              }}</span>
              <span v-else-if="scope.row.twoScoreNumber">{{
                scope.row.twoScoreNumber
              }}</span>
              <span
                v-if="scope.row.threeScoreNumber && scope.row.twoScoreNumber"
                >({{ scope.row.threeScoreNumber }}、{{
                  scope.row.twoScoreNumber
                }})</span
              >
              <span v-else-if="scope.row.threeScoreNumber"
                >({{ scope.row.threeScoreNumber }}、0)</span
              >
              <span v-else-if="scope.row.twoScoreNumber"
                >(0、{{ scope.row.twoScoreNumber }})</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="oneScoreNumber"
            label="差评数(1星)"
            width="120"
          ></el-table-column>
          <el-table-column label="好评率">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.goodCommentRate==100">>99.99%</span> -->
              <!-- <span v-if="scope.row.goodCommentRate!=100&&scope.row.goodCommentRate!=0">{{ scope.row.goodCommentRate }}%</span> -->
              <!-- <span v-if="scope.row.goodCommentRate==0"><0.01%</span> -->
              <span>{{ scope.row.goodCommentRate }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="更新时间"
            width="110"
          ></el-table-column>
          <el-table-column label="评价历史">
            <template slot-scope="scope">
              <span
                class="see"
                v-zoom="{ from: pageName, name: '查看' }"
                @click="seeOpen(scope.row.venderId, scope.row.skuId)"
                >查看</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="p1" label="计算好评" width="180">
            <template slot-scope="scope">
              <ul class="calculation">
                <li>
                  好评率
                  <el-input
                    placeholder="100"
                    style="width: 65px; margin: 0 6px"
                    maxlength="5"
                    v-model="scope.row.rate"
                    @change="rowRateChange(scope.row)"
                  ></el-input
                  >%
                </li>
                <li>
                  需删除中差评：
                  <span style="color: #fe4d45">{{
                    scope.row.needDelBabComment
                  }}</span>
                </li>
                <li>
                  或新增好评：
                  <span style="color: #fe4d45">{{
                    scope.row.needAddGoodComment
                  }}</span>
                </li>
              </ul>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          background
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <!-- 添加会员 对话框 -->
    <el-dialog
      title="商品评价详情"
      :visible.sync="addMember"
      width="1000px"
      :before-close="handleDialogCloseAnoths"
      class="addMemberDialog"
    >
      <template slot="empty">
        <div>
          <img src="@/assets/images/default/暂无任何数据.png" />
          <span style="margin-left: -140px">暂无任何数据</span>
        </div>
      </template>
      <el-form>
        <el-form-item label="">
          <el-radio
            v-model="queryForm.evaluateTime"
            @change="timeChange"
            v-for="item in options.evaluateTimeOpt"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="postForm.startDate"
              type="datetime"
              :placeholder="'选择日期时间'"
              @change="timeChange1"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div
              class="time_to_text"
              :class="{
                to_text_disabled:
                  queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
              }"
            >
              至
            </div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="postForm.endDate"
              type="datetime"
              :placeholder="'选择日期时间'"
              @change="timeChange1"
              size="small"
              :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              class="time2"
              :clearable="true"
            ></el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearTimeSendTime()"
            ></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
        </el-form-item>
      </el-form>
      <!-- v-loading="loading" -->
      <div
        style="height: 380px; width: 900px; margin: 20px"
        ref="payRemindChart"
        class="chart"
      ></div>
    </el-dialog>

    <!-- 生成报表 -->
    <generate :control = 'control' 
            v-if="control" 
            @transData="(val) => (control = val)"
            @transData1 = 'getphone1'
            ></generate>

  </div>
</template>

<script>
import qs from "qs";
import topTitle from "@/components/top-title";
import inputForm from "@/components/inputForm";
import echarts from "echarts";
import { getSellercats,popCommentWareAnalysisExport } from "@/api/analysis/ware-controller";
import generate from '../../components/generate_report.vue'
import {
  getList,
  calculateGoodComment,
  synchroJdWare,
  goodsUpdate,
  getArticleDaysSummary,
  queryGetArticleDaysSummary,
  querygetWarePopCommentAnalysisDetail,
} from "@/api/serviceCenter/popCommentWareAnalysis";

let serial = 0; // 表格序号
export default {
  components: {
    inputForm,
    generate
  },
  data() {
    return {
      control:false,
      pageName: "售后中心-商品评价分析",
      queryForm: {
        evaluateTime: "7",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "30",
            label: "近1个月",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
      queryListContent: {},
      inputData: [
        {
          name: "商品类目:",
          val: "cid",
          cascaderArr: [],
          multiple: true,
        },
        {
          name: "评价数:",
          iptArr: [
            { val: "totalCommentNumStart", placeholder: "请输入" },
            { val: "totalCommentNumEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "好评率:",
          iptArr: [
            { val: "goodCommentRateStart", placeholder: "请输入" },
            { val: "goodCommentRateEnd", placeholder: "请输入" },
          ],
        },
        {
          name: "商品编码:",
          val: "wareId",
          placeholder: "请输入商品编号, 多个请用,隔开",
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID, 多个请用,隔开",
        },
        {
          name: "统计时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      // 全店商品评价分析开关
      analysis: true,
      // 表格数据
      tableData: [],
      // 分页配置
      current: 1,
      size: 10,
      total: 0,
      addMember: false,
      loading: false,
      venderId1: "",
      skuId1: "",
      chartEffectDetail: {},
      formData: {},
    };
  },
  created() {
    // 获取商品类目
    getSellercats().then((res) => {
      let data = this.transverter(res.data);
      this.getTrees(data);
      let list = data.filter((item) => item.parent_id == 0);
      let cascaderArr = list.map((item) => {
        return {
          label: item.label,
          value: item.value,
          children: item.children,
        };
      });

      this.inputData[0].cascaderArr = cascaderArr;
    });

    // 埋点
    this.buriedPoint(1, '商品评价分析', '数据分析', '评价分析')
  },
  mounted() {
    this.$refs.searchForm.submitForm("formSearch");
    // this.queryTotal();
  },
  methods: {
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    /**
     * 表单查询
     */
    //评价历史查看按钮
    seeOpen(venderId, skuId) {
      this.addMember = true;
      this.venderId1 = venderId;
      this.skuId1 = skuId;
      this.queryForm.evaluateTime = "30";
      this.timeChange(30);
      //  this.queryTotal();
    },
    //重置
    clearTimeSendTime() {
      this.queryForm.evaluateTime = "7";
      this.timeChange(7);
      this.queryTotal();
    },

    handleDialogCloseAnoths() {
      this.addMember = false;
      this.queryForm.evaluateTime = "7";
    },
    //     queryListOne(form, state){
    //  if(form.totalCommentNumStart>form.totalCommentNumEnd){
    //         this.$message.error('评价数开始值不可大于结束值')
    //         return
    //       }
    //       if(form.goodCommentRateStart>form.goodCommentRateEnd){
    //         this.$message.error('好评率开始值不可大于结束值')
    //         return
    //       }
    //       console.log(form);
    //       console.log(state);
    //       this.loading = true;
    //       form.current = state ? 1 : this.current;
    //       console.log(form.current);
    //       form.size = this.size;
    //       // console.log(form.cid);
    //       form.cid =form.cid?form.cid.join(","): ""
    //       // console.log(this.current);
    //       serial=(form.current-1)*10;
    //       this.queryListContent=form;
    //     },
    queryList(form, state) {
      if (form.totalCommentNumStart > form.totalCommentNumEnd) {
        this.$message.error("评价数开始值不可大于结束值");
        return;
      }
      if (form.goodCommentRateStart > form.goodCommentRateEnd) {
        this.$message.error("好评率开始值不可大于结束值");
        return;
      }
      console.log(form);
      console.log(state);
      this.loading = true;
      // console.log(state=="reset");
      if (state == true || state == "reset") {
        form.current = 1;
      } else {
        form.current = this.current;
      }
      //  = state ? 1 :
      form.size = this.size;
      console.log(form.current);
      // console.log(form.cid);
      form.cid = form.cid ? form.cid.join(",") : "";
      // console.log(this.current);
      serial = (form.current - 1) * 10;
      this.formData = form;
      getList(form).then((res) => {
        res &&
          res.data.records.forEach((item) => {
            item.serial = serial++;
            item.rate = null;
            item.needAddGoodComment = 0;
            item.needDelBabComment = 0;
          });
        this.tableData = res && res.data.records;
        this.total = res && res.data.total;
        this.loading = false;
      });
    },

    timeChange(type) {
      let self = this;
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      console.log(date);
      if (type == null) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
        this.queryTotal();
      } else if (type == 7) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
        this.queryTotal();
      } else if (type == 15) {
        this.mytime[0] = self.getDay(-15, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
        this.queryTotal();
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
        this.queryTotal();
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
    //自定义后时间变化查询
    timeChange1() {
      const start = Date.parse(new Date(this.postForm.startDate));
      const end = Date.parse(new Date(this.postForm.endDate));
      if (start > end) {
        this.$message.warning("时间选择错误");
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      } else {
        if (this.postForm.startDate != "" && this.postForm.endDate != "") {
          this.queryTotal();
        }
      }
    },
    //查询数据总和
    queryTotal() {
      //折线图数据查询

      querygetWarePopCommentAnalysisDetail({
        venderId: this.venderId1,
        skuId: this.skuId1,
        creationTimeStart: this.postForm.startDate,
        creationTimeEnd: this.postForm.endDate,
      })
        .then((res) => {
          console.log(res);
          if (res.data.length == 1 && res.data.length == 0) {
            this.$message.error("折线图时间过短");
          } else if (res.data.length > 1) {
            var dataList = res.data;
            // console.log(dataList);
            var badCommentNum = []; //差评数量
            var goodCommentNum = []; //好评数量
            var middleCommentNum = []; //中评数量
            var totalCommentNum = []; //总评论数量
            var createTime = []; //时间
            dataList.forEach((item) => {
              badCommentNum.push(item.badCommentNum);
              goodCommentNum.push(item.goodCommentNum);
              middleCommentNum.push(item.middleCommentNum);
              totalCommentNum.push(item.totalCommentNum);
              createTime.push(item.createTime);
            });
            this.chartEffectDetail = {
              badCommentNum: badCommentNum, //差评数量
              goodCommentNum: goodCommentNum, //好评数量
              middleCommentNum: middleCommentNum, //中评数量
              totalCommentNum: totalCommentNum, //总评论数量
              createTime: createTime,
            };
          } else {
            this.chartEffectDetail = {
              badCommentNum: [], //差评数量
              goodCommentNum: [], //好评数量
              middleCommentNum: [], //中评数量
              totalCommentNum: [], //总评论数量
              createTime: [],
            };
          }
          if (res.data && res.data.code === 0) {
            this.$message.error(res.data.message);
          }
          this.$nextTick(() => {
            this.initChart();
            window.addEventListener("resize", () => {
              this.myCharts.resize();
            });
          });
        })
        .catch((res) => {
          // this.$message.error("输入时间错误");
        });
    },
    //折线图
    initChart() {
      console.log("initChart");
      this.myCharts = echarts.init(this.$refs.payRemindChart);
      this.setOptions(this.chartEffectDetail);
      // console.log(this.chartEffectDetail);
    },
    //折线图事件
    setOptions({
      badCommentNum,
      goodCommentNum,
      middleCommentNum,
      totalCommentNum,
      createTime,
    } = {}) {
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["评价数", "好评数", "中评数", "差评数"],
          bottom: -5,
          left: 60,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: createTime,
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            name: "评价数",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#7F85E9",
            data: totalCommentNum,
          },
          {
            name: "好评数",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#5882FB",
            data: goodCommentNum,
          },
          {
            name: "中评数",
            type: "line",
            color: "#FF872F",
            areaStyle: {},
            smooth: true,
            data: middleCommentNum,
          },
          {
            name: "差评数",
            type: "line",
            color: "#FE4D45",
            areaStyle: {},
            smooth: true,
            data: badCommentNum,
          },
        ],
      };

      this.myCharts.setOption(option);
    },

    // 商品好评率变化监听
    rowRateChange(data) {
      console.log(data.rate);
      console.log(data.goodCommentRate);
      data.rate = +data.rate > 100 ? 100 : +data.rate;
      const params = {
        goodCommentNum: +data.fiveScoreNumber + +data.fourScoreNumber,
        totalCommentNum: data.totalCommentNum,
        calGoodCommentRate: data.rate,
      };
      calculateGoodComment(params).then((res) => {
        data.needAddGoodComment = res && res.data.needAddGoodComment;
        data.needDelBabComment = res && res.data.needDelBabComment;
      });
    },
    // 下载数据
    handleDownload() {
      this.control = true
    },
    getphone1(val){
      this.formData.exportRemark = val
      popCommentWareAnalysisExport(qs.stringify(this.formData)).then((res)=>{
        if(res.code==1){
          this.control = true
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 同步店铺商品
    syncShopGood() {
      synchroJdWare().then((res) => {
        if (res && res.code == 1) {
          this.$message.success("同步成功");
          this.$refs.searchForm.submitForm("formSearch");
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 更新
    handleUpdate() {
      if (this.tableData.length <= 0) {
        this.$message.warning("暂无数据");
        return;
      }
      const ids = this.tableData.map((item) => item.id).join(",");
      goodsUpdate({ ids: ids }).then((res) => {
        if (res && res.code == 1) {
          this.$message.success("更新成功");
          this.$refs.searchForm.submitForm("formSearch");
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    /**
     * 分页事件
     */
    handleSizeChange(val) {
      this.size = val;
      this.current = 1;
      serial = 0;
      this.$refs.searchForm.submitForm("formSearch");
    },
    handleCurrentChange(val) {
      this.current = val;
      this.$refs.searchForm.submitForm("formSearch");
    },
  },
};
</script>

<style lang="scss" scoped>
.allGoodsAssess {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1100px;
  .addMemberDialog {
  }
  button {
    margin: 0;
    padding: 0 12px;
    height: 32px;
    line-height: 30px;
    border: none;
    outline: none;
    border-radius: 3px;
    background-color: #fff;
    cursor: pointer;
    transition: all 0.3s;
  }
  .headForm {
    box-sizing: border-box;
    margin-top: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .headTips {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 54px;
      padding: 0 28px;
      border-bottom: 1px solid #f0f0f0;
      .leftFlex,
      .rightFlex {
        display: flex;
        align-items: center;
      }
      h4 {
        margin: 0 12px 0 0;
        color: #2e3458;
        font-size: 16px;
      }
      .desc {
        color: #333;
        font-size: 14px;
      }
    }
  }
  .content {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    margin-top: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .titBtns {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #333;
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 20px;
      .leftBtn {
        display: flex;
        .refreshBtn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 98px;
          color: #fff;
          background: rgba(254, 77, 69, 1);
          margin-right: 8px;
          &:hover {
            opacity: 0.8;
          }
          .refresh {
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }
        }
        .synchroBtn {
          width: 120px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(0, 0, 0, 0.6);
          border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
          &:hover {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
          &:active {
            color: #fff;
            border: none;
            background-color: #fe4d45;
          }
        }
        .downloadBtn {
          width: 120px;
          height: 32px;
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        
          &:hover {
            color: #fff;
            border: none;
            background-color: #fe4d45;
          }
          &:active {
            color: #fff;
            border: none;
            background-color: #fe4d45;
          }
        }
      }
    }
    .shopInfo {
      display: flex;
      align-items: center;
      height: 100px;
      .avar {
        flex-shrink: 0;
        width: 58px;
        height: 58px;
        margin-right: 16px;
        border-radius: 50%;
        background-color: #f6f6f6;
      }
      .descBox {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: #333;
        font-size: 14px;
        font-weight: 400;
        .tit {
          line-height: 20px;
        }
        .shopId {
          color: #999;
        }
      }
    }
    .calculation {
      display: flex;
      flex-direction: column;
      li {
        display: flex;
        align-items: center;
      }
    }
    .see {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
      font-weight: 500;
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>